import React from 'react';
import { Meteor } from 'meteor/meteor';
import Moment from 'react-moment';
import moment from 'moment';
import ReactDOM from 'react-dom';

import {
	Col,
	BPanel,
	Radio,
	FormGroup,
	FormControl,
	ControlLabel,
	Modal,
	Button,
	Table,
	Checkbox
} from '@sketchpixy/rubix';
import TimePicker from 'react-bootstrap-time-picker';

import { Flights } from '../../collections/flights/flights';
import { Montgolfieres } from '../../collections/montgolfieres/montgolfieres';
import { Users } from '../../collections/users/users';

import { encloseFlight } from '../../collections/flights/methods';

export class PlanningClotureModal extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
			takeOffTime: this.props.flight.period == 'morning' ? 9 : 16,
			landingTime: this.props.flight.period == 'morning' ? 9 : 16,
			montgolfiereId:  this.props.flight.montgolfiereId,
			pilotId: this.props.flight.pilotId
		};
		
		_.extend(this.state, {
			takeOffDate: moment(this.props.flight.date).add(this.state.takeOffTime, 'hours').toDate(),
			landingDate: moment(this.props.flight.date).add(this.state.landingTime, 'hours').toDate()
		});
	}

	componentWillReceiveProps() {
		this.setState({
			takeOffTime: this.props.flight.period == 'morning' ? 9 : 16,
			landingTime: this.props.flight.period == 'morning' ? 9 : 16
		});
		this.setState({
			takeOffDate: moment(this.props.flight.date).add(this.state.takeOffTime, 'hours').toDate(),
			landingDate: moment(this.props.flight.date).add(this.state.landingTime, 'hours').toDate(),
			pilotId: this.props.flight.pilotId,
			montgolfiereId: this.props.flight.montgolfiereId
		});
	}

	closeModal() {
		this.setState({ showModal: false });
	}


	openModal() {
		this.setState({ showModal: true });
	}

	montgolfieres() {
		return Montgolfieres.find({}).fetch();
	}

	pilots() {
		return Meteor.users.find({}).fetch();
	}

	updatePilot(pilotId) {
		this.setState({ pilotId: pilotId });
	}

	updateMontgolfiere(montgolfiereId) {
		this.setState({ montgolfiereId: montgolfiereId });
	}

	encloseFlight() {

		encloseFlight.call({
			_id: this.props.flight._id,
			takeOffDate: this.state.takeOffDate,
			landingDate: this.state.landingDate,
			takeOffPlace: ReactDOM.findDOMNode(this.refs.takeOffPlace).value.trim(),
			landingPlace: ReactDOM.findDOMNode(this.refs.landingPlace).value.trim(),
			montgolfiereId: this.state.montgolfiereId,
			pilotId: this.state.pilotId
		}, ((err) => {
			if (err)
				return Messenger().post({
					message: err,
					type: "error"
				});

			Messenger().post({
				message: "Le vol a été clôturé avec succès.",
				type: "success"
			});

			this.closeModal();
		}).bind(this));
	}
	
	getTimeRange() {
		if (!this.props.flight)
			return { start: '0', end: '23' };

		if (this.props.flight.period == 'morning') 
			return { start: '0', end: '23:55' };
		else
			return { start: '0', end: '23:55' };
	}
	
	setTakeOffDate(takeOffTime) {
		this.setState({
			takeOffTime,
			takeOffDate: moment(this.props.flight.date).add(takeOffTime, 'seconds').toDate()
		});
	}

	setLandingDate(landingTime) {
		this.setState({
			landingTime,
			landingDate: moment(this.props.flight.date).add(landingTime, 'seconds').toDate()
		});
	}

	renderModal() {
		return (
			<Modal show={this.state.showModal} onHide={::this.closeModal}>
				<Modal.Header closeButton>
					<Modal.Title>Cloture du vol du { moment(this.props.flight.date).format("DD/MM/YYYY") } - { this.props.flight.getPeriod() } - { this.props.flight.getPlace() }</Modal.Title>
				</Modal.Header>
				<Modal.Body>

					<FormGroup controlId="formControlsSelect">
						<ControlLabel>Montgolfiere :</ControlLabel>
						<FormControl componentClass="select" placeholder="Montgolfiere" onChange={(e) => this.setState({ montgolfiereId: e.target.value })} defaultValue={this.props.flight.montgolfiereId}>
							{this.montgolfieres().map((montgolfiere) => {
								return (
									<option value={montgolfiere._id}>{montgolfiere.name}</option>
								);
							})}
						</FormControl>
					</FormGroup>

					<FormGroup controlId="formControlsSelect">
						<ControlLabel>Pilote :</ControlLabel>
						<FormControl componentClass="select" placeholder="Pilote" onChange={(e) => this.updatePilot(e.target.value)} defaultValue={this.props.flight.pilotId}>
							{this.pilots().map((pilot) => {
								return (
									<option value={pilot._id}>{ pilot.profile.firstName + ' ' + pilot.profile.lastName }</option>
								);
							})}
						</FormControl>
					</FormGroup>

					<hr/>

					<strong>Informations de la cloture :</strong><br/><br/>
					<FormGroup controlId="formControlsSelect">
						<Col sm={5}><ControlLabel>Heure d'envol :</ControlLabel></Col>
						<Col sm={7}>
							<TimePicker start={this.getTimeRange().start} end={this.getTimeRange().end} step={5} format={24} onChange={::this.setTakeOffDate} value={this.state.takeOffTime}/>
						</Col>
					</FormGroup> 
					<br/><br/>

					<FormGroup controlId="formControlsSelect">
						<Col sm={5}><ControlLabel>Lieu d'envol :</ControlLabel></Col>
						<Col sm={7}>
							<FormControl type="text" ref="takeOffPlace"/>
						</Col>
					</FormGroup> 
					<br/><br/>

					<FormGroup controlId="formControlsSelect">
						<Col sm={5}><ControlLabel>Heure d'atterrissage :</ControlLabel></Col>
						<Col sm={7}>
							<TimePicker start={this.getTimeRange().start} end={this.getTimeRange().end} step={5} format={24} onChange={::this.setLandingDate} value={this.state.landingTime}/>
						</Col>
					</FormGroup>
					<br/><br/>
					
					<FormGroup controlId="formControlsSelect">
						<Col sm={5}><ControlLabel>Lieu d'atterrissage :</ControlLabel></Col>
						<Col sm={7}>
							<FormControl type="text" ref="landingPlace"/>
						</Col>
					</FormGroup>
					<br/><br/>
				</Modal.Body>
				<Modal.Footer>
					<Button bsStyle="success" onClick={::this.encloseFlight}>Cloturer</Button>
				</Modal.Footer>
			</Modal>
		);

	}

	render() {
		return ( 
				<div>
					<Button bsStyle="primary" onClick={this.openModal.bind(this)}>Cloturer mon vol</Button>
					{this.state.showModal && this.renderModal()}
				</div>
			   );
	}

}




/** WEBPACK FOOTER **
 ** ./src/universal/components/flights/PlanningClotureModal.js
 **/